// extracted by mini-css-extract-plugin
module.exports = {"root":"Order_root__1b0cw","main":"Order_main__1djDY","secondary":"Order_secondary__10xCy"};